import React, { useState } from "react";
import { MdOutlineRemoveRedEye } from "react-icons/md";

export default function MobileEmpProject({
  projects = [],
  onView,
  onStatusChange,
}) {
  const [openStatusProject, setOpenStatusProject] = useState(null);

  if (!projects || projects.length === 0) {
    return (
      <p className="text-center text-gray-500 text-sm py-6">
        No projects found
      </p>
    );
  }

  const priorityColor = (priority) => {
    switch (priority) {
      case "high":
        return "text-red-600";
      case "medium":
        return "text-yellow-500";
      case "on-hold":
        return "text-orange-500";
      case "active":
        return "text-blue-500";
      default:
        return "text-green-600";
    }
  };

  const handleStatusSelect = (projectId, status) => {
    onStatusChange(projectId, { target: { value: status } });
    setOpenStatusProject(null);
  };

  return (
    <>
      <div className="flex flex-col gap-3">
        {projects.map((project) => (
          <div
            key={project.id}
            onClick={() => onView(project)}
            className="relative bg-gray-100 border rounded-md shadow-sm p-4 cursor-pointer transition active:scale-[0.98]"
          >
            {/* 👁 Eye Icon Top Right */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                onView(project);
              }}
              className="absolute top-2 right-2 text-blue-600 text-xl"
            >
              <MdOutlineRemoveRedEye />
            </button>

            {/* Project ID */}
            <p className="text-xs text-gray-500 font-medium">Project ID</p>
            <p className="text-sm text-gray-800">{project.id}</p>

            {/* Project Name */}
            <p className="text-xs text-gray-500 font-medium mt-2">
              Project Name
            </p>
            <p className="text-base font-semibold text-gray-900 leading-snug">
              {project.projectName}
            </p>

            {/* Client */}
            <p className="text-xs text-gray-500 font-medium mt-2">Client</p>
            <p className="text-sm text-gray-700">{project.clientName}</p>

            {/* Assigned Date */}
            <p className="text-xs text-gray-500 font-medium mt-2">
              Assigned Date
            </p>
            <p className="text-sm text-gray-700">
              {project.assignedDate}
            </p>

            {/* Priority */}
            <div className="mt-2">
              <span className="text-xs text-gray-500 font-medium">
                Priority
              </span>
              <p
                className={`text-sm font-semibold capitalize ${priorityColor(
                  project.priority
                )}`}
              >
                {project.priority}
              </p>
            </div>

            {/* Status Button */}
            <div
              className="mt-3"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setOpenStatusProject(project)}
                className="w-full border border-zinc-400 rounded p-2 text-sm text-left bg-gray-50"
              >
                Status:{" "}
                <span className="capitalize font-medium">
  {project.status === "in-progress"
    ? "Active"
    : project.status.replace("-", " ")}
</span>

              </button>
            </div>
          </div>
        ))}
      </div>

      {/* ===== STATUS POPUP ===== */}
      {openStatusProject && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
          onClick={() => setOpenStatusProject(null)}
        >
          <div
            className="bg-white rounded-lg w-[90%] max-w-sm p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <p className="text-sm font-semibold text-gray-800 mb-3 text-center">
              Change Project Status
            </p>

            {["pending", "in-progress", "on-hold", "completed"].map(
              (status) => (
                <button
                  key={status}
                  onClick={() =>
                    handleStatusSelect(openStatusProject.id, status)
                  }
                  className={`w-full text-left p-3 rounded mb-2 capitalize text-sm ${
                    openStatusProject.status === status
                      ? "bg-blue-100 text-blue-700 font-semibold"
                      : "bg-gray-100 text-gray-700"
                  }`}
                >
                  {status === "in-progress" ? "active" : status.replace("-", " ")}
                </button>
              )
            )}

            <button
              onClick={() => setOpenStatusProject(null)}
              className="w-full mt-2 text-sm text-gray-500"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
}
